import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { SaveFoodPreferenceData } from './MiscModel';
import { misc } from '../../api/Endpoints';
import { QUERY_KEYS } from '../../api/config';

export const useSaveFoodPreference = (
  options?: Partial<UseMutationOptions<object, Error, SaveFoodPreferenceData>>,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn: (data: SaveFoodPreferenceData) => {
      return misc.saveFoodPreference(data);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.INIT_DATA] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.ALL_FOODS] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.NUTRITION_SUMMARY_DETAIL] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.NUTRITION_SUMMARY_DETAIL_BLOOD_SUGAR] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PLANT_VIRUS] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.IMPROVE_SCORE_DETAIL] });
    },
  });
};
